import { inject, InjectionToken } from '@angular/core';

/**
 * All available project names in this monorepo.
 * Use these constants instead of hardcoded strings for type safety.
 *
 * Note: these values are sent to Amplitude as the `project` event property.
 * They were renamed from the historical "*onboarding" values on 2026-07-31,
 * so Amplitude queries spanning that date must match both spellings.
 * women-kindle-funnel became romance-funnel on 2026-09-08; Amplitude queries
 * spanning that date must match both.
 */
export const ProjectNames = {
  FUNNEL: 'funnel',
  GOOGLE_FUNNEL: 'google-funnel',
  APPLOVIN_FUNNEL: 'applovin-funnel',
  SHORT_FUNNEL: 'short-funnel',
  KINDLE_FUNNEL: 'kindle-funnel',
  ROMANCE_FUNNEL: 'romance-funnel',
  READER_FUNNEL: 'reader-funnel',
  APPLICATION: 'application',
} as const;

export type ProjectName = (typeof ProjectNames)[keyof typeof ProjectNames];

/**
 * Injection token for the current project name.
 * Value is provided via file replacement at build time.
 */
export const PROJECT_NAME = new InjectionToken<ProjectName>('PROJECT_NAME');

/**
 * The deployment the visitor actually landed on, as opposed to the funnel flow they are being
 * shown. The two differ only on the AppLovin domain, whose build swaps PROJECT_NAME to the main
 * or Kindle funnel via `?funnel=`; everywhere else the build serves its own funnel and the
 * default below makes the two identical. Use this - never PROJECT_NAME - to scope anything to
 * the traffic of one domain.
 */
export const HOST_PROJECT_NAME = new InjectionToken<ProjectName>('HOST_PROJECT_NAME', {
  providedIn: 'root',
  factory: () => inject(PROJECT_NAME),
});
